import * as S from "effect-app/Schema"

export const ConfiguratorTagId = S.StringId
export type ConfiguratorTagId = S.StringId

export const TagColor = S.String.pipe(S.check(S.isPattern(/^#[0-9A-Fa-f]{6}$/)))
export type TagColor = typeof TagColor.Type

export class ConfiguratorTag extends S.Opaque<ConfiguratorTag, ConfiguratorTag.Encoded>()(
  S
    .Struct({
      id: ConfiguratorTagId.withConstructorDefault,
      name: S.NonEmptyString255,
      color: TagColor
    })
    .annotate({ identifier: "ConfiguratorTag" })
) {}

// codegen:start {preset: model}
//
export namespace ConfiguratorTag {
  export interface Encoded extends S.StructNestedEncoded<typeof ConfiguratorTag> {}
}
//
// codegen:end
